const getApplyPagination = () => {
    return `
    export const applyPagination = (array, page, limit) => array
        .slice(page * limit, page * limit + limit);
    `;
}

export default getApplyPagination;
